import { SummarySearch } from "@/types/OrderItem";
import {
  SalesOrderSearch,
  SalesOrderSearchResult,
  SalesOrderSummaryResult,
  DeleteResponse
} from "@/types/SalesOrder";
import { createApi } from "@reduxjs/toolkit/query/react";
import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";

export const SalesOrderApi = createApi({
  reducerPath: "SalesOrderApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["salesorder"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getSalesOrder: builder.query({
      query: () => {
        return `/salesorder`;
      },
      providesTags: ["salesorder"],
    }),
    uploadDocument: builder.mutation({
      query: ({ formData }) => ({
        url: `/document/salesorder/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["salesorder"],
    }),
    searchOrders: builder.query<SalesOrderSearchResult, SalesOrderSearch>({
      query: (input) => ({
        url: `/salesorder/search`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["salesorder"],
    }),
    exportSalesOrder: builder.mutation<Blob, SalesOrderSearch>({
      query: (input) => ({
        url: `/salesorder/search`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    summaryOrders: builder.query<SalesOrderSummaryResult, SalesOrderSearch>({
      query: (input) => ({
        url: `/salesorder/summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["salesorder"],
    }),
    deleteSalesReturns: builder.mutation<DeleteResponse, string[]>({
      query: (ids) => ({
        url: "/salesorder/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["salesorder"],
    }),
  }),
});

export const {
  useGetSalesOrderQuery,
  useUploadDocumentMutation,
  useSearchOrdersQuery,
  useLazySearchOrdersQuery,
  useExportSalesOrderMutation,
  useSummaryOrdersQuery,
  useDeleteSalesReturnsMutation
} = SalesOrderApi;
